/**
 * Adapptio Shared library.
 *
 * @package lib-shared
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import lodashMerge from "lodash.merge";

export function mergeDeep(target: unknown, source: unknown): unknown {
	return lodashMerge(target, source);
}
